import {Injectable, OnInit} from '@angular/core';
import {SiteIndexPageScoresTableRowModel} from '../models/SiteIndexPageScoresTableRowModel';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {HttpService} from './http.service';
import {GetSiteResponseDto} from '../models/GetSiteResponseDto';
import {SitePageScoresTableRowModel} from '../models/SitePageScoresTableRowModel';

@Injectable()
export class SitesService implements OnInit {
    onSitesIndexPagesScoresLoaded: Subject<Array<SiteIndexPageScoresTableRowModel>>;
    onSiteLoadedSubject: Subject<GetSiteResponseDto>;
    onSitePagesScoresLoaded: Subject<Array<SitePageScoresTableRowModel>>;

    constructor(private httpService: HttpService) {
        this.onSitesIndexPagesScoresLoaded = new Subject<Array<SiteIndexPageScoresTableRowModel>>();
        this.onSiteLoadedSubject = new Subject<GetSiteResponseDto>();
        this.onSitePagesScoresLoaded = new Subject<Array<SitePageScoresTableRowModel>>();
    }
    ngOnInit(): void {}

    getById(id: number): void {
        const siteId = id.toString();
        const url = environment.ENDPOINTS.GET_SITE_BY_ID.replace('{:id}', siteId);
        this.httpService.getJson<GetSiteResponseDto>(url)
            .subscribe(response => this.onSiteLoadedSubject.next(response.body));
    }

    getOnSiteLoadedSubject(): Observable<GetSiteResponseDto> {
        return this.onSiteLoadedSubject.asObservable();
    }

    getAllSitesIndexPagesScoresByDateAndAccumulatorId(scoreAccumulatorId: number, reviewDate: string): void {
        const id = scoreAccumulatorId.toString();
        const url = environment.ENDPOINTS.GET_ALL_SITES_INDEX_PAGES_SCORES_BY_DATE_AND_ACCUMULATOR_ID
            .replace('{:scoreAccumulatorId}', id)
            .replace('{:reviewDate}', reviewDate);

        this.httpService.getJson<Array<SiteIndexPageScoresTableRowModel>>(url)
            .subscribe(response => { this.onSitesIndexPagesScoresLoaded.next(response.body); });
    }

    getOnSitesIndexPagesScoresLoadedSubject(): Observable<Array<SiteIndexPageScoresTableRowModel>> {
        return this.onSitesIndexPagesScoresLoaded.asObservable();
    }

    getSitePagesScores(siteId: number, scoreAccumulatorId: number, reviewDate: string): void {
        const id = siteId.toString();
        const accumulatorId = scoreAccumulatorId.toString();
        const url = environment.ENDPOINTS.GET_SITE_PAGES_SCORES
            .replace('{:siteId}', id)
            .replace('{:scoreAccumulatorId}', accumulatorId)
            .replace('{:reviewDate}', reviewDate);
        this.httpService.getJson<Array<SitePageScoresTableRowModel>>(url).subscribe(response => {
            this.onSitePagesScoresLoaded.next(response.body);
        });
    }

    getOnSitePagesScoresLoaded(): Observable<Array<SitePageScoresTableRowModel>> {
        return this.onSitePagesScoresLoaded.asObservable();
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/sites.service.ts